import { addClass, removeClass } from "@oddcamp/js-utils/src/attribute"
import { getElements } from "@oddcamp/js-utils/src/selector"
import { addEventListener } from "@oddcamp/js-utils/src/event"
import { delegateEventListener } from "@oddcamp/js-utils/src/event"
import turboInit from "../utils/turbo-init"

// user nav

turboInit(() => {
  const container = document.querySelector(`.vb-nav--portal__header__user`)
  if (!container) return

  const button = container.querySelector(`:scope > button`)

  button.addEventListener(`click`, () => container.classList.toggle(`--active`))

  document.addEventListener(`click`, (e) => {
    if (!e.target.closest(`.vb-nav--portal__header__user`)) {
      container.classList.remove(`--active`)
    }
  })

  document.addEventListener(`keyup`, (e) => {
    if (e.key == `Escape`) {
      container.classList.remove(`--active`)
    }
  })
})

// admin user nav

delegateEventListener(`.admin-bar__user button`, `click`, () => {
  addClass(`.admin-bar__user`, `--active`)
})

delegateEventListener(`.admin-bar__user button.-close`, `click`, () => {
  removeClass(`.admin-bar__user`, `--active`)
})

turboInit(() => {
  const adminContainer = document.querySelector(`.admin-bar__user`)
  if (!adminContainer) return

  document.addEventListener(`click`, (e) => {
    if (!e.target.closest(`.admin-bar__user`)) {
      removeClass(`.admin-bar__user`, `--active`)
    }
  })

  document.addEventListener(`keyup`, (e) => {
    if (e.key == `Escape`) {
      removeClass(`.admin-bar__user`, `--active`)
    }
  })
})

// admin nav

turboInit(() => {
  const toggleEl = document.querySelector(`.admin-bar__toggle button`)
  if (!toggleEl) return

  const toggleContainer = document.querySelector(`.admin-header`)

  toggleEl.addEventListener(`click`, () => {
    toggleEl.classList.toggle(`--active`)
    toggleContainer.classList.toggle(`--active`)
    toggleContainer.parentElement.classList.toggle(`--active`)
  })

  document.addEventListener(`click`, (e) => {
    if (
      !e.target.closest(`.admin-header`) &&
      !e.target.closest(`.admin-bar__toggle`)
    ) {
      toggleContainer.classList.remove(`--active`)
      toggleEl.classList.remove(`--active`)
      toggleContainer.parentElement.classList.remove(`--active`)
    }
  })
})

// admin nav toggles

turboInit(() => {
  const toggleEls = getElements(`.admin-header__nav button`)
  const targetEls = getElements(`.admin-header__nav .-sub`)
  if (!toggleEls.length) return

  addEventListener(toggleEls, `click`, (e, triggerEl) => {
    const isActive = triggerEl.classList.contains(`--active`)
    removeClass(toggleEls, `--active`)
    removeClass(targetEls, `--active`)

    if (!isActive) {
      triggerEl.classList.add(`--active`)
      const target = triggerEl.nextElementSibling
      if (target && target.matches(`.-sub`)) {
        target.classList.add(`--active`)
      }
    }
  })
})

turboInit(() => {
  const vbNav = document.querySelector(`.vb-nav`)
  if (!vbNav) return

  // when scrolling vbNav height then add borderColor
  const scrollHandler = () => {
    if (window.scrollY > 0) {
      vbNav.classList.add(`-scrolled`)
    } else {
      vbNav.classList.remove(`-scrolled`)
    }
  }

  if (vbNav.classList.contains(`vb-nav--scrollable`)) {
    window.addEventListener(`scroll`, scrollHandler)
    scrollHandler()
  }

  const buttons = document.querySelectorAll(
    `.vb-nav__nav button, .vb-nav__extra-links button.-js-auth-btn, .vb-nav .-sign-in-btn`
  )

  buttons.forEach((button) => {
    button.addEventListener(`click`, () => {
      if (!button.classList.contains(`-js-auth-btn`)) {
        document.querySelector(`.-js-auth-btn`)?.classList?.remove(`-active`)
        vbNav.querySelector(`.-auth-sub-menu`)?.classList?.remove(`-active`)
      }

      vbNav.classList.remove(`-dropdown-expanded`)
      vbNav.classList.remove(`-auth-dropdown-expanded`)
      vbNav.style.paddingBottom = null

      document
        .querySelectorAll(`.vb-nav .vb-nav__inner button`)
        .forEach((btnEl) => {
          if (btnEl !== button) btnEl.classList.remove(`-active`)
        })

      document
        .querySelectorAll(
          `.vb-nav .vb-nav__inner .sub-menu, .vb-nav__extra-links .sub-menu`
        )
        .forEach((subMenu) => {
          if (subMenu !== button.nextElementSibling)
            subMenu.classList.remove(`-active`)
          if (
            vbNav.classList.contains(`vb-nav--scrollable`) &&
            window.scrollY === 0
          ) {
            vbNav.classList.remove(`-scrolled`)
          }
        })

      button.classList.toggle(`-active`)
      const target = button.nextElementSibling
      if (target && target.matches(`.sub-menu, .-auth-sub-menu`)) {
        target.classList.toggle(`-active`)
      }

      if (target && target.classList.contains(`-active`)) {
        vbNav.style.paddingBottom = `${target.scrollHeight}px`
        vbNav.classList.add(`-dropdown-expanded`)

        if (
          button.classList.contains(`-js-auth-btn`) ||
          button.classList.contains(`-sign-in-btn`)
        ) {
          vbNav.classList.add(`-auth-dropdown-expanded`)
        }

        if (
          vbNav.classList.contains(`vb-nav--scrollable`) &&
          window.scrollY === 0
        ) {
          vbNav.classList.toggle(`-scrolled`)
        }
      }
    })
  })

  const hamburgerBtnEl = document.querySelector(`#vb-nav-hamburger-btn`)
  if (!hamburgerBtnEl) return

  hamburgerBtnEl.addEventListener(`click`, () => {
    vbNav.classList.toggle(`-mobile-menu-expanded`)
    hamburgerBtnEl.querySelector(`.vb-hamburger`).classList.toggle(`is-active`)

    hamburgerBtnEl.classList.toggle(`-active`)
  })

  const mobileButtons = document.querySelectorAll(
    `.vb-nav .vb-nav__mobile button.-js-toggler`
  )

  mobileButtons.forEach((button) => {
    button.addEventListener(`click`, () => {
      mobileButtons.forEach((btnEl) => {
        if (btnEl !== button) btnEl.classList.remove(`-active`)
      })

      document
        .querySelectorAll(`.vb-nav .vb-nav__mobile .sub-menu`)
        .forEach((subMenu) => {
          if (subMenu !== button.nextElementSibling)
            subMenu.classList.remove(`-active`)
        })

      button.classList.toggle(`-active`)
      button.nextElementSibling.classList.toggle(`-active`)
    })
  })

  const outsideClickHandler = (event) => {
    if (
      vbNav.classList.contains(`-dropdown-expanded`) &&
      !vbNav.contains(event.target)
    ) {
      vbNav.classList.remove(`-auth-dropdown-expanded`)
      vbNav.querySelector(`.-auth-sub-menu`).classList.remove(`-active`)
      vbNav.classList.remove(`-dropdown-expanded`)
      vbNav.style.paddingBottom = null
      document.querySelector(`.-js-auth-btn`)?.classList?.remove(`-active`)

      document
        .querySelectorAll(`.vb-nav .vb-nav__inner button`)
        .forEach((btnEl) => {
          btnEl.classList.remove(`-active`)
        })

      document
        .querySelectorAll(
          `.vb-nav .vb-nav__inner .sub-menu, .vb-nav__extra-links .sub-menu`
        )
        .forEach((subMenu) => {
          subMenu.classList.remove(`-active`)
        })

      if (
        vbNav.classList.contains(`vb-nav--scrollable`) &&
        window.scrollY === 0
      ) {
        vbNav.classList.remove(`-scrolled`)
      }
    }
  }

  document.addEventListener(`click`, outsideClickHandler)

  const dropdownCloseBtnEl = document.querySelector(
    `.vb-nav .-js-nav-close-dropdown`
  )

  const closeClickHandler = () => {
    vbNav.classList.remove(`-dropdown-expanded`)
    vbNav.classList.remove(`-auth-dropdown-expanded`)
    vbNav.style.paddingBottom = null

    if (
      vbNav.classList.contains(`vb-nav--scrollable`) &&
      window.scrollY === 0
    ) {
      vbNav.classList.remove(`-scrolled`)
    }

    document
      .querySelectorAll(`.vb-nav .vb-nav__inner button`)
      .forEach((btnEl) => {
        btnEl.classList.remove(`-active`)
      })

    document
      .querySelectorAll(
        `.vb-nav .vb-nav__inner .sub-menu, .vb-nav__extra-links .sub-menu`
      )
      .forEach((subMenu) => {
        subMenu.classList.remove(`-active`)
      })

    document.querySelector(`.-js-auth-btn`)?.classList?.remove(`-active`)
  }

  if (dropdownCloseBtnEl) {
    dropdownCloseBtnEl.addEventListener(`click`, () => closeClickHandler)
  }

  // eslint-disable-next-line consistent-return
  return () => {
    /* 1. remove global listeners */
    window.removeEventListener(`scroll`, scrollHandler)
    document.removeEventListener(`click`, outsideClickHandler)
    dropdownCloseBtnEl?.removeEventListener(`click`, closeClickHandler)

    /* 2. close all open states / inline styles */
    vbNav.classList.remove(
      `-mobile-menu-expanded`,
      `-dropdown-expanded`,
      `-auth-dropdown-expanded`,
      `-scrolled`
    )
    vbNav.style.paddingBottom = null
    vbNav
      .querySelectorAll(
        `.vb-nav__inner button, .vb-nav__mobile button.-js-toggler, .vb-nav__extra-links button`
      )
      .forEach((el) => el.classList.remove(`-active`))
    vbNav
      .querySelectorAll(
        `.sub-menu, .vb-nav__extra-links .sub-menu, .-auth-sub-menu`
      )
      .forEach((el) => el.classList.remove(`-active`))
  }
})
